import { Component } from 'react'
import { Link } from 'react-router-dom'
import Table from '../../../components/table'
import ApproveModal from './approve-modal'
import RepproveModal from '../candidate/repprove-modal'
import searchIcon from '../../../../assets/icons/search.png'
import filterIcon from '../../../../assets/icons/filter.png'
import infoIcon from '../../../../assets/icons/info.png'
import storageIcon from '../../../../assets/icons/storage.png'
import checkIcon from '../../../../assets/icons/check.png'
import badgeIcon from '../../../../assets/icons/badge.png'
import deleteIcon from '../../../../assets/icons/delete-white.png'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { listJobApplies } from '../../../../insfrastructure/services/job-applies'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import moment from 'moment'
import './styles.sass'
import { formatDate, normalizeDateOnlyFromApi } from '../../../../insfrastructure/utils/date-formatter'
import { logger } from '../../../../insfrastructure/services/analytics'
import { isNetworkError } from '../../../../insfrastructure/utils/errors'

class Candidates extends Component<any> {
  state: any = {
    offer: {},
    candidates: {
      data: [],
      count: 0,
      attended_count: 0
    },
    offset: 0,
    jobapply_status: {},
    marital_status: {},
    selectedApprovedCandidate: null,
    selectedRepprovedCandidate: null,
    selectedCandidateForInterview: null,
    loading: false,
    search: '',
    jobErrorMessage: '',
    candidatesErrorMessage: ''
  }

  componentDidMount() {
    logger.info('Candidates component mounted', {
      offer_id: this.props.params?.offer_id,
      category: 'candidates_view'
    });
    
    try {
      this.retriveJob();
      this.listCandidates({});
      this.getStaticValues();
    } catch (error) {
      logger.error('Erro ao inicializar componente Candidates', error as Error, {
        offer_id: this.props.params?.offer_id,
        category: 'candidates_view'
      });
    }
  }

  retriveJob = async () => {
    const offerId = this.props.params?.offer_id;
    
    logger.info('Buscando vaga para exibir candidaturas', {
      offer_id: offerId,
      category: 'candidates_view'
    });
    
    try {
      if (!offerId) {
        throw new Error('offer_id não fornecido');
      }
      
      this.setState({ jobErrorMessage: '' });
      const response = await listJobs({ id: offerId });
      
      if (!response?.data || response.data.length === 0) {
        throw new Error('Vaga não encontrada');
      }
      
      const offer = response.data[0];
      this.setState({ offer });
      
      logger.info('Vaga recuperada com sucesso', {
        offer_id: offerId,
        jobpost_id: offer?.jobpostId,
        category: 'candidates_view'
      });
    } catch (error) {
      if (isNetworkError(error)) {
        logger.warn('Erro de rede ao buscar vaga para visualizar candidaturas', {
          offer_id: offerId,
          category: 'candidates_view',
          error_type: error instanceof Error ? error.constructor.name : typeof error
        });
        this.setState({
          jobErrorMessage: 'Não foi possível carregar a vaga. Verifique sua conexão e tente novamente.'
        });
        return;
      }

      logger.error('Erro ao buscar vaga para visualizar candidaturas', error as Error, {
        offer_id: offerId,
        category: 'candidates_view',
        error_type: error instanceof Error ? error.constructor.name : typeof error
      });
      this.setState({
        jobErrorMessage: 'Não foi possível carregar os dados da vaga no momento.'
      });
    }
  }

  listCandidates = async (params: Record<string, any>) => {
    const offerId = this.props.params?.offer_id;
    
    logger.info('Buscando lista de candidaturas', {
      offer_id: offerId,
      search: params?.search,
      category: 'candidates_view'
    });
    
    try {
      this.setState({ loading: true, candidatesErrorMessage: '' });

      if (!offerId) {
        throw new Error('offer_id não fornecido para buscar candidaturas');
      }

      const candidates: any = {
        data: [],
        count: 0,
        attended_count: 0
      };
      
      const response = await listJobApplies(offerId);
      
      if (!Array.isArray(response)) {
        throw new Error('Resposta da API não é um array de candidaturas');
      }

      candidates.data = response;
      candidates.count = response.length;
      candidates.attended_count = response.filter(x => x?.status && x.status !== 'applied').length;

      this.setState({ candidates });
      
      logger.info('Candidaturas carregadas com sucesso', {
        offer_id: offerId,
        total_count: candidates.count,
        attended_count: candidates.attended_count,
        category: 'candidates_view'
      });
      
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 1000);
    } catch (error) {
      if (isNetworkError(error)) {
        logger.warn('Erro de rede ao buscar lista de candidaturas', {
          offer_id: offerId,
          search: params?.search,
          category: 'candidates_view',
          error_type: error instanceof Error ? error.constructor.name : typeof error,
          error_message: error instanceof Error ? error.message : String(error)
        });
        this.setState({
          candidatesErrorMessage: 'Não foi possível carregar as candidaturas. Verifique sua conexão e tente novamente.'
        });
      } else {
        logger.error('Erro ao buscar lista de candidaturas', error as Error, {
          offer_id: offerId,
          search: params?.search,
          category: 'candidates_view',
          error_type: error instanceof Error ? error.constructor.name : typeof error,
          error_message: error instanceof Error ? error.message : String(error)
        });
        this.setState({
          candidatesErrorMessage: 'Não foi possível carregar as candidaturas no momento.'
        });
      }
      
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 500);
    }
  }

  getStaticValues = async () => {
    logger.info('Buscando valores estáticos para componente Candidates', {
      category: 'candidates_view'
    });
    
    try {  
      setTimeout(() => {
        try {
          const staticValuesStr = localStorage.getItem('static_values');
          
          if (!staticValuesStr) {
            throw new Error('Valores estáticos não encontrados no localStorage');
          }
          
          const staticValues = JSON.parse(staticValuesStr) as StaticValues;
          
          if (!staticValues) {
            throw new Error('Valores estáticos inválidos no localStorage');
          }
          
          const jobapply_status = staticValues.jobapply_status || {};
          const marital_status = staticValues.marital_status || {};
          const disability = staticValues.disability || {};
          
          this.setState({ jobapply_status, marital_status, disability });
          
          logger.info('Valores estáticos carregados com sucesso', {
            has_jobapply_status: !!jobapply_status && Object.keys(jobapply_status).length > 0,
            has_marital_status: !!marital_status && Object.keys(marital_status).length > 0,
            has_disability: !!disability && Object.keys(disability).length > 0,
            category: 'candidates_view'
          });
        } catch (parseError) {
          logger.error('Erro ao processar valores estáticos do localStorage', parseError as Error, {
            category: 'candidates_view',
            error_type: parseError instanceof Error ? parseError.constructor.name : typeof parseError
          });
        }
      }, 1000);
    } catch (error) {
      logger.error('Erro ao buscar valores estáticos', error as Error, {
        category: 'candidates_view',
        error_type: error instanceof Error ? error.constructor.name : typeof error
      });
    }
  }

  getCandidateAge = (date_of_birth_string: string) => {
    try {
      if (!date_of_birth_string) {
        logger.warn('Tentativa de calcular idade com data de nascimento vazia', {
          category: 'candidates_view'
        });
        return 0;
      }
      
      var current_date = moment();
      const normalized = normalizeDateOnlyFromApi(date_of_birth_string);
      var date_of_birth = normalized ? moment(normalized, 'YYYY-MM-DD') : moment(date_of_birth_string);
      
      if (!date_of_birth.isValid()) {
        logger.warn('Data de nascimento inválida ao calcular idade', {
          date_of_birth_string,
          category: 'candidates_view'
        });
        return 0;
      }
      
      var years = current_date.diff(date_of_birth, 'years');
      
      if (years < 0 || years > 150) {
        logger.warn('Idade calculada fora do intervalo esperado', {
          years,
          date_of_birth_string,
          category: 'candidates_view'
        });
        return 0;
      }
      
      return years;
    } catch (error) {
      logger.error('Erro ao calcular idade do candidato', error as Error, {
        date_of_birth_string,
        category: 'candidates_view'
      });
      return 0;
    }
  }

  onSearch = async () => {
    this.listCandidates({ search: this.state.search });
  }

  toggleApproveCandidateModal = (candidate?: any) => {
    this.setState({ selectedApprovedCandidate: candidate });
  }

  onCandidateApproved = async () => {
    this.toggleApproveCandidateModal();
    this.props.navigate('/offers');
  }

  toggleRepproveCandidateModal = (candidate?: any) => {
    this.setState({ selectedRepprovedCandidate: candidate });
  }

  onCandidateRepproved = async () => {
    this.listCandidates({});
    this.toggleRepproveCandidateModal();
  }

  toggleCallForInterviewModal = (candidate?: any) => {
    this.setState({ selectedCandidateForInterview: candidate ? candidate : null });
  }

  onCandidateCalledForInterview = async () => {
    this.setState({ selectedCandidateForInterview: null });
  }

  calculatePercentage = () => {
    const { candidates, loading } = this.state;
    
    // Se estiver carregando, retorna 0
    if (loading) {
      return 0;
    }
    
    // Se não houver candidatos, retorna 0
    if (!candidates.count || candidates.count === 0) {
      return 0;
    }
    
    // Calcula a porcentagem
    const percentage = (candidates.attended_count / candidates.count) * 100;
    
    // Garante que o valor é um número válido
    if (!isFinite(percentage) || isNaN(percentage)) {
      return 0;
    }
    
    // Arredonda para 2 casas decimais
    return Math.round(percentage * 100) / 100;
  }

  render() {
    try {
      const jobTitleName = this.state.offer?.jobTitle?.name || 'Vaga';
      
      return (
        <div className='job-candidates company-page'>
          <div className='block'>
              <div className='block-header'>
                <div className='title'>
                  <img src={storageIcon} alt='storage-icon' />
                  <h3><Link to={'/offers'}>Vagas {'>'}</Link> {jobTitleName} - Candidatos</h3>
                </div>
              </div>
            {this.state.jobErrorMessage && (
              <div className='error-message' style={{ color: '#B00020', margin: '8px 0', fontSize: '13px' }}>
                {this.state.jobErrorMessage}
              </div>
            )}
            {this.state.candidatesErrorMessage && (
              <div className='error-message' style={{ color: '#B00020', margin: '8px 0', fontSize: '13px' }}>
                {this.state.candidatesErrorMessage}
              </div>
            )}
            <div className='general-vision'>
              <div className='data'>
                <h3>Visão Geral</h3>
                <h4>Candidatos: <b>{this.state.candidates?.count ?? 0}</b></h4>
                <h4>Atendidos: <b>{this.state.candidates?.attended_count ?? 0}</b></h4>
              </div>
              <div className='graph-container'>
                {(() => {
                  try {
                    return <CircularChart percentage={this.calculatePercentage()} />;
                  } catch (error) {
                    logger.error('Erro ao renderizar gráfico de candidatos atendidos', error as Error, {
                      category: 'candidates_view'
                    });
                    return <div>Gráfico indisponível</div>;
                  }
                })()}
                <h4>Atendidos</h4>
              </div>
            </div>
            <div className='searcher'>
              <img className='search-icon' src={searchIcon} alt='search-icon' onClick={this.onSearch} />
              <input type='text' placeholder='Pesquisar candidato' onChange={e => this.setState({ search: e.target.value })} />
              <img className='filter-icon' src={filterIcon} alt='filter-icon' />
            </div>
            <div className='candidates'>
              <Table
                data={this.state.candidates.data}
                total={this.state.candidates.count}
                limit={10}
                offset={this.state.offset}
                loading={this.state.loading}
                onNavigate={(params: any) => {
                  // listCandidates({ offset: params.offset, search });
                }}
                header={
                  <thead>
                    <tr>
                      <th className='name'>Nome do candidato:</th>
                      <th className='basic-info'>Dados básicos:</th>
                      <th className='pcd'>PcD?</th>
                      <th className='date'>Atualização da candidatura:</th>
                      <th className='actions'></th>
                    </tr>
                  </thead>
                }
                body={
                  (candidates: any) => {
                    if (!Array.isArray(candidates)) {
                      logger.error('Dados de candidatos não são um array na renderização', undefined, {
                        candidates_type: typeof candidates,
                        candidates_value: candidates,
                        category: 'candidates_view'
                      });
                      return [];
                    }
                    
                    return candidates.map(
                      (candidate: any, index: number) => {
                        try {
                          if (!candidate) {
                            logger.warn('Candidato nulo ou indefinido encontrado na lista', {
                              index,
                              category: 'candidates_view'
                            });
                            return null;
                          }
                          
                          const maritalStatusText = this.state.marital_status?.[candidate.marital_status] || '';
                          const disabilityText = this.state.disability?.[candidate.has_disabilities] || '';
                          
                          return (
                            <tr key={'candidate_'+index} className={candidate.status && ['rejected', 'not_fit'].includes(candidate.status) ? 'not-hired' : ''}>
                              <td>{candidate.name || 'Nome não disponível'}</td>
                              <td>
                                <p>
                                  {maritalStatusText}
                                  {candidate.date_of_birth && ', ' + this.getCandidateAge(candidate.date_of_birth) + ' anos'}
                                </p>
                                <p>{candidate.city_display_name || 'Cidade não disponível'}</p>
                              </td>
                              <td>{disabilityText || '-'}</td>
                              <td>
                                {candidate.status_updated_at ? (
                                  <span>{formatDate(candidate.status_updated_at)}</span>
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                              <td>
                                <div className='actions'>
                                  {candidate.id && this.props.params?.offer_id ? (
                                    <Link to={'/offers/'+this.props.params.offer_id+'/candidates/'+candidate.id} state={{ offer_id: this.props.params.offer_id }}>
                                      <button className='access'>
                                        <img src={infoIcon} alt='info-icon' />
                                        <span>Conheça o candidato</span>
                                      </button>
                                    </Link>
                                  ) : (
                                    (() => {
                                      logger.warn('Link de candidato inválido - falta ID ou offer_id', {
                                        candidate_id: candidate.id,
                                        offer_id: this.props.params?.offer_id,
                                        category: 'candidates_view'
                                      });
                                      return null;
                                    })()
                                  )}
                                  {candidate.status === 'applied' && (
                                    <span className='status applied'>
                                      <img src={badgeIcon} alt='badge-icon' />
                                      <span>Aplicado</span>
                                    </span>
                                  )}
                                  {candidate.status === 'interview' && (
                                    <>
                                      <button className='remove' onClick={() => this.toggleRepproveCandidateModal(candidate)}>
                                        <img src={deleteIcon} alt='delete-icon' />
                                        <span>Reprovado</span>
                                      </button>
                                      <button className='hire' onClick={() => this.toggleApproveCandidateModal(candidate)}>
                                        <img src={checkIcon} alt='check-icon' />
                                        <span>Aprovado</span>
                                      </button> 
                                    </>
                                  )}
                                  {candidate.status === 'hired' && (
                                    <span className='status hired'>
                                      <img src={badgeIcon} alt='badge-icon' />
                                      <span>Contratado</span>
                                    </span>
                                  )}
                                  {candidate.status === 'rejected' && (
                                    <span className='status not-hired'>
                                      <img src={deleteIcon} alt='delete-icon' />
                                      <span>Reprovado</span>
                                    </span>
                                  )}
                                  {candidate.status === 'not_fit' && (
                                    <span className='status not-hired'>
                                      <img src={deleteIcon} alt='delete-icon' />
                                      <span>Não Apto</span>
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        } catch (renderError) {
                          logger.error('Erro ao renderizar candidato na lista', renderError as Error, {
                            candidate_index: index,
                            candidate_id: candidate?.id,
                            candidate_name: candidate?.name,
                            category: 'candidates_view'
                          });
                          return null;
                        }
                      }
                    ).filter(Boolean);
                  }
                }/>
            </div>
        </div>
        <ApproveModal
        render={this.state.selectedApprovedCandidate}
        candidate={this.state.selectedApprovedCandidate}
        jobapply_id={this.state.selectedApprovedCandidate?.id}
        onClose={this.toggleApproveCandidateModal}
        onSubmitted={this.onCandidateApproved} />
        <RepproveModal
        status='rejected'
        render={this.state.selectedRepprovedCandidate}
        candidate={this.state.selectedRepprovedCandidate}
        jobapply_id={this.state.selectedRepprovedCandidate?.id}
        onClose={this.toggleRepproveCandidateModal}
        onSubmitted={this.onCandidateRepproved} />
      </div>
      );
    } catch (renderError) {
      logger.error('Erro crítico ao renderizar componente Candidates', renderError as Error, {
        offer_id: this.props.params?.offer_id,
        offer: this.state.offer,
        candidates_count: this.state.candidates?.count,
        category: 'candidates_view'
      });
      
      return (
        <div className='job-candidates company-page'>
          <div className='block'>
            <div className='block-header'>
              <div className='title'>
                <img src={storageIcon} alt='storage-icon' />
                <h3>Erro ao carregar candidaturas</h3>
              </div>
            </div>
            <p>Ocorreu um erro ao carregar as candidaturas. Por favor, recarregue a página.</p>
          </div>
        </div>
      );
    }
  }
}

export default withRouter(Candidates)

export const CircularChart = ({ percentage }: { percentage: number }) => {
  // Garante que a porcentagem é sempre um número válido entre 0 e 100
  const safePercentage = !isFinite(percentage) || isNaN(percentage) 
    ? 0 
    : Math.max(0, Math.min(100, percentage));
  
  // Formata para exibição (sem casas decimais se for inteiro)
  const displayPercentage = safePercentage % 1 === 0 
    ? Math.round(safePercentage) 
    : safePercentage.toFixed(1);

  return (
    <svg width={100} height={100} viewBox="0 0 36 36">
      <path className="circle-bg" style={{
         fill: 'none',
         stroke: '#E6E6E6',
         strokeWidth: 2.5
      }}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke="#9FD67B"
        strokeWidth="2.5"
        strokeDasharray={`${safePercentage}, 100`}
        style={{ transition: '0.5s' }}
      />
      <text x="50%" y="50%" textAnchor="middle" fill="black" fontSize="8px" dy=".3em">{displayPercentage}%</text>
    </svg>
  )
}
